import React from 'react';

import Text from '~/components/core/TextComponents/Text';
import useCurrencyFormatter from '~/components/CurrencyFormatterContext';
import type { SummaryItem } from '~/components/types/invoice-types';

interface LineItemsAmountSummaryProps {
  items: SummaryItem[];
}

export const LineItemsAmountSummary: React.FC<LineItemsAmountSummaryProps> = ({ items }) => {
  const { currencyFormatter } = useCurrencyFormatter();

  const visibleItems = items.filter((item) => item.display);

  if (visibleItems.length === 0) return null;

  return (
    <div className="mt-16 flex flex-row items-center justify-start gap-32 rounded-md bg-blueSky-100 px-24 py-16">
      {visibleItems.map((item) => (
        <div key={item.key} className="flex flex-row items-baseline gap-12">
          <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.MEDIUM} className="text-slate-800">
            {item.label}:
          </Text>
          <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.SEMI_BOLD} className="text-slate-900">
            {currencyFormatter.format(item.value)}
          </Text>
        </div>
      ))}
    </div>
  );
};
